var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDropdownOptionsWrapper',{class:{ invisible: _vm.hasNoOptionsEnabled },attrs:{"is-horizontal":true,"options":_vm.options},on:{"select":_vm.handleDropdownSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }